import React from "react";
import "./Pages.css";
import chat from "../../assets/chat.png";
import announcement from "../../assets/announcement.png"

const Anzeige = () => {
  return (
    <div className="anzeige">
      {/* */}
      <img width={300} src={announcement} alt="Anzeige" /><pre/>
      <p style={{color:"red"}}>
      <strong>Praxis geschlossen</strong><pre/>
      Liebe Patienten,<pre/>
      wir machen Urlaub von 26.10.2026 bis 30.10.2026 <pre/>
      an folgenden Tagen ist die Praxis für Terminvergabe, Rezepte geöffnet.<pre/>
      Montag den 26.10.2026 von 08:00 bis 12:30 Uhr<pre/>
      Dienstag den 27.10.2026 von 08:00 bis 12:30 uhr <pre/>
      Ab Montag den 02.11.2026 sind wir wieder zu den gewohnten Sprechszeiten da.<pre/>
       <pre/>
      in dringenden Fällen wenden Sie sich bitte an das nächstgelegene Krankenhaus oder rufen Sie die 116117 an. <pre/>
      
        Ihr URO-Praxisteam<pre /><pre />
      </p><pre/><pre/> 
      <img width={300} src={chat} alt="Anzeige" />
      <p>
        Sehr geehrte Patienten <pre/>‚
        <pre/>
        Wir sind eine Facharztpraxis, da kann es schon durchaus zu etwas längeren
        Wartezeiten kommen. Dafür bitte wir um Verständnis.<pre/>
        <pre/>
        Die Untersuchung bei Neupatienten ist immer etwas aufwändiger. Bitte planen
        Sie genügend Zeit ein.<pre/>
        <pre/>
        Wir haben mehrere Untersuchungs-/Behandlungsräume, deswegen kann es
        auch durchaus sein, dass ein Patient, der nach Ihnen kam, vor Ihnen aufgerufen
        wird.<pre/>
        <pre/>
        Viele Patienten kommen z.B. nur zur Blutabnahme, Katheterwechsel usw. und
        müssen an diesem Tag nicht zum Arzt.<pre/>
        Das sind Untersuchungen, die von den Fachangestellten durchgeführt
        werden.<pre/>
        <pre/>
        An manchen Tagen haben wir auch Notfälle. Dies sind Patienten mit z.B.
        Koliken und unter Schmerzen können diese Patienten nicht warten und
        brauchen zeitnah eine Versorgung.<pre/>
        <pre/>
        Wir bitten um Ihr Verständnis<pre/>
        Ihr URO-Praxisteam<pre /><pre />
      </p>
    </div>
  );
};

export default Anzeige;
